"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthHeader = void 0;
const getAuthHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('ivAccessToken')}`
});
exports.getAuthHeader = getAuthHeader;
